import Layout from "@/layout/Layout";
import globalStyle from '@/styles/Global.scss'
import React, {useEffect, useState} from "react";
import {Schedule} from "@/entity/Schedule";
import {useHistory, useParams} from "react-router";
import {getScheduleDateOf, updateSchedule, deleteSchedule, exportSchedule} from "@/api/schedule";
import MButton from "@/components/atom/MButton";
import {Form} from "react-bootstrap";
import dayjs from "dayjs";
import {saveDownloadFile} from "@/util/file";

const EditSchedule = () => {
  const { date } = useParams();
  const history = useHistory()
  const [schedule, setSchedule] = useState(new Schedule({}))

  useEffect(() => {
    (async () => {
      const schedule = await getScheduleDateOf({date}) || null
      setSchedule(schedule)
    })()
  }, [date])

  const edit = async () => {
    await updateSchedule({id: schedule.id, schedule})
    history.push(`/schedule`)
  }

  const doDelete = async () => {
    if (!window.confirm(`スケジュールを削除してもよいですか？`)) {
      return
    }
    await deleteSchedule({id: schedule.id})
    history.push(`/schedule`)
  }

  const back = () => {
    history.push(`/schedule`)
  }

  return (
    <>
      <Layout category={'WA'} title={'スケジュール登録'}>
        <div className={globalStyle.container}>
          {
            schedule && <>
              <Form>
                <Form.Group className="mb-3">
                  {dayjs(schedule.date).format('YYYY年MM月DD日')}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>営業日</Form.Label>
                  <Form.Select value={`${schedule.holiday}`} aria-label="営業日"
                               onChange={(e) => setSchedule(new Schedule({...schedule, holiday: e.target.value}))}>
                    <option value={'false'}>営業日</option>
                    <option value={'true'}>休業日</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>営業時間</Form.Label>
                  <Form.Control type="text" value={schedule.businessHour}
                                onChange={(e) => setSchedule(new Schedule({...schedule, businessHour: e.target.value}))}
                                placeholder="営業時間を入力してください。"/>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>メモ</Form.Label>
                  <Form.Control as="textarea" value={schedule.memo}
                                onChange={(e) => setSchedule(new Schedule({...schedule, memo: e.target.value}))}
                                placeholder="メモを入力してください。"/>
                </Form.Group>
              </Form>
            </>
          }
          <MButton image={'henkou.png'} value={'更新'} onClick={edit}></MButton>
          <MButton image={'sakujo.png'} value={'削除'} onClick={doDelete}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={back}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default EditSchedule
